<template>
  <div class="noticeBar" v-if="notificationList.length > 0">
    <i class="iconfont icon-tongzhi-icon" />
    <swiper class="swiper-no-swiping" ref="noticeBarSwiper" :options="swiperOptions">
      <swiper-slide v-for="item in notificationList" :key="item.id">
        <span>{{ item.content }}</span>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { commonApi } from '../views/home/service';

export default {
  data () {
    return {
      swiperOptions: {
        autoplay: {
          delay: 10000
        },
        loop: true,
        speed: 1000,
        direction: 'vertical'
      },
      notificationList: []
    };
  },
  methods: {
    getNotificationList () {
      commonApi.getNotificationList().then(res => {
        if (res.status === '200') {
          this.notificationList = res.data;
        }
      });
    }
  },
  mounted () {
    this.getNotificationList();
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/common.scss';
.noticeBar{
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #ffffff;
  padding-left: 50px;
  padding-right: 16px;
  color: #424C57;
  position: relative;

  >i{
    margin-right: 12px;
    position: absolute;
    left: 16px;
  }
  >.swiper-container{
    width: 100%;
    height: 100%;
    .swiper-slide{
      @extend .textOverflow;
    }
    //.swiper-wrapper{
    //  height: 50px!important;
    //}
    //.swiper-slide{
    //  height: 50px!important;
    //}
  }
}
</style>
